import * as React from 'react';
import { Store } from '../State';
import * as ReactDOM from 'react-dom';
import { saveAppShellData, appShellComponentName } from '../AppShell/utils';
import { autoResolveDynamicData, setLanguage } from '../DynamicData';
import { resolveThemeContext } from '../resolve-component';
import { exposeScopeState } from '../events';
import { initialRenderDone } from '../CurrentPage/is-initial-render';
import ErrorBoundary from './ErrorBoundary';
import { setupScopeStateHooks } from '../use-scope-state';

export const scopeSiteContainerAttribute = 'avensia-scope-root';

export default async function browserRender(store: Store, container: Element, element: React.ReactElement<any>) {
  exposeScopeState(store);
  setupScopeStateHooks(store);

  if ((store.getState().appShellData as any).pageIsInEditMode) {
    (window as any).IS_IN_EDIT_MODE = true;
  }

  await (store.getState().currentTheme ? resolveThemeContext(store.getState().currentTheme) : Promise.resolve(null));

  container.setAttribute(scopeSiteContainerAttribute, 'true');
  element = <ErrorBoundary>{element}</ErrorBoundary>;

  setLanguage(store.getState().appShellData.culture);

  // I'd prefer if we did this after rendering, but the rendering might trigger Dynamic Data
  // resolves and if rendering takes more time than the batch size we risk firing many
  // Dynamic Data requests
  autoResolveDynamicData([store.getState().currentPage, store.getState().appShellData]);

  await new Promise(resolve => {
    if (
      window.IS_SERVER_SIDE_RENDERED &&
      store.getState().appShellData.guessedBreakpoint === store.getState().currentBreakpoint
    ) {
      ReactDOM.hydrate(element, container, resolve);
    } else {
      ReactDOM.render(element, container, resolve);
    }
  });

  await saveAppShellData(store.getState().appShellData);

  // If the component name is appshelldata, the render is from SW and we will re-render
  // when we get the real component.
  if (store.getState().currentPage.componentName !== appShellComponentName) {
    initialRenderDone();
  }
}

export function enableSeparateAssetsHost() {
  const webPackPublicPath = (window as any).WEBPACK_ASSETS_HOST;
  if (webPackPublicPath) {
    __webpack_public_path__ = '//' + webPackPublicPath + '/';
  }
}
